import { and, count, menu_product, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveMenuProductFilters } from "./filters";

/**
 * Counts LIVE catalog products from local SQLite. Feeds
 * `checkUnsyncedActor` ("keep local data?" prompt when migrating visitor
 * to real account): previously did RAW `count() from(menu_product)` in
 * `auth/controllers.ts`, also counting trashed ones (dispersed invariant
 * bug — deleted product triggered "you have local data" prompt).
 * Via live layer only counts live ones (and excludes category in trash,
 * by `liveMenuProductFilters` cohort) — consistent with other views.
 * (Visitor→real merge runs via `sweepVisitorData` anyway, so
 * no row is lost; this counter only decides whether prompt is SHOWN.)
 */
export function getLiveMenuProductCountForUserQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ total: count() })
    .from(menu_product)
    .where(and(...liveMenuProductFilters()));
}
